import { COUNTRIES } from "./countriesList";

const ISO_SET = new Set(COUNTRIES.map((c) => c.value));

/**
 * EU member states (ISO 3166-1 alpha-2), used to build the EEA shortcut list.
 * Update when membership changes.
 */
const EU_MEMBER_CODES = [
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "HU",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
];

/** EEA = EU + Iceland, Liechtenstein, Norway (non-EU EEA states). */
const EEA_EXTRA_CODES = ["IS", "LI", "NO"];

/**
 * Raw shortcut definitions. Only codes present in {@link COUNTRIES} are kept at runtime.
 * @type {{ id: string, label: string, codes: string[] }[]}
 */
const RAW_APPLICANT_COUNTRY_GROUPS = [
  {
    id: "EEA",
    label: "European Economic Area (EEA)",
    codes: [...EU_MEMBER_CODES, ...EEA_EXTRA_CODES],
  },
];

/**
 * Country groups for applicant profile shortcuts (e.g. add all EEA states in one action).
 * `countryCodes` is filtered to the sovereign list in `countriesList.js`.
 */
export const APPLICANT_COUNTRY_GROUPS = RAW_APPLICANT_COUNTRY_GROUPS.map((g) => ({
  id: g.id,
  label: g.label,
  countryCodes: [...new Set(g.codes.filter((c) => ISO_SET.has(String(c || "").trim().toUpperCase())))],
})).filter((g) => g.countryCodes.length > 0);
